
















































































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { fetchUserSessionResult, fetchUserSessionFeedback } from "@/api.ts";
import { UserSessionResult, SessionResult, SessionFeedback } from "@/types";
import { Results, NewResults } from "../../types/NewResults";
import transcript from "@/components/review/userReviewTranscript.vue";
import player from "@/components/Player.vue";
import videoProgress from "@/components/VideoProgress.vue";
import feedbackVideo from "@/components/review/userReviewVideo.vue";
import MetricHolder from "@/components/results/MetricHolder.vue";
import Filler from "@/components/results/Filler.vue";
import Energy from "@/components/results/Energy.vue";
import Conciseness from "@/components/results/Conciseness.vue";
import Pace from "@/components/results/Pace.vue";
import Confidence from "@/components/results/Confidence.vue";
import Clarity from "@/components/results/Clarity.vue";
import Expression from "@/components/results/Expression.vue";
import AudioStatement from "@/components/results/AudioStatement.vue";

@Component({
  components: {
    transcript,
    feedbackVideo,
    player,
    videoProgress,
    MetricHolder,
    Filler,
    Energy,
    Expression,
    Conciseness,
    Pace,
    AudioStatement,
    Clarity,
    Confidence,
  },
})
export default class ReviewResult extends Vue {
  @Prop() private teamID!: string;
  @Prop() private sessionID!: string;
  @Prop() private sessionReviewed!: string;
  @Prop() private isUserFromLearner!: boolean;
  @Prop() private learnerName!: string;
  @Prop() private token: string | undefined;

  @Getter private JWT!: string;
  @Getter private reviewCommentPlay!: number;
  @Getter private sessionFeedback!: SessionFeedback[];

  @Action private setReviewCommentPlay!: any;

  private error: boolean = false; // API error
  private errorMsg: string = "Something went wrong.";

  private sessionResult: Results | null = null;
  private recordingTitle: string | null = null;
  private learnerNameFromResult: string | null = null;
  private isPortrait: boolean = false;
  private videoProgressPercentage: number = 0;
  private videoCurrentTimeChange: number = 0;
  private videoDuration: number = 0;
  private isVideoPlaying: boolean = false;
  private playbackRate: number = 1;
  private isViewOraiFeedback: boolean = false;
  private activemetric: string = "";
  private transcriptText: string[] = [];
  private playsegment: number[] = [];
  private scrollY = 0;
  //private isPlayFromAudioStatement = { isPlay: false };

  private created() {
    if (this.sessionID) {
      fetchUserSessionResult(
        this.token === undefined ? this.JWT : this.token,
        this.sessionID,
        (newResult: NewResults) => {
          this.recordingTitle = newResult.Title;
          this.learnerNameFromResult = this.getResultLearnerName(newResult);
          this.sessionResult = newResult.Results;
          // this.sessionResult.displayCategories = this.sessionResult.displayCategories.map(
          //   (t) => t.charAt(0).toUpperCase() + t.slice(1)
          // );
          this.activemetric = this.sessionResult.displayCategories[0];
          this.transcriptText = this.sessionResult.transcript.split(" ");
        },
        (error: string) => {

          this.error = true;
          this.errorMsg = error;
        }
      );
    }
  }

  private setActiveMetric(metric: string) {
    this.activemetric = metric;
    console.log(this.activemetric);
  }

  private getMetricScore(metric: string) {
    if (this.sessionResult) {
      if (metric === "expression") {
        let primary = this.sessionResult.details.expression.primary;
        return primary.charAt(0).toUpperCase() + primary.slice(1);
      } else if (metric === "energy") {
        return this.sessionResult.details.energy.score + "%";
      } else if (metric === "pace") {
        return this.sessionResult.details.pace.score + "%";
      } else if (metric === "conciseness") {
        return this.sessionResult.details.conciseness.score + "%";
      } else if (metric === "confidence") {
        return this.sessionResult.details.confidence.score + "%";
      } else if (metric === "fillers") {
        if (this.sessionResult.details.fillers.fillerWords.length > 0) {
          let fillerWords = this.sessionResult.details.fillers.fillerWords.reduce(
            (partialSum: number, a: any) => partialSum + a.occurrences,
            0
          );

          return fillerWords + " words";
        } else {
          return (
            this.sessionResult.details.fillers.fillerWords.length + " words"
          );
        }
      } else if (metric === "clarity") {
        return this.sessionResult.details.clarity.score + "%";
      } else {
        return "";
      }
    }
  }

  private onOrientation(isPortrait: boolean) {
    this.isPortrait = isPortrait;
  }

  private onProgress(progress: number) {
    this.videoProgressPercentage = progress;
  }

  private onVideoDuration(duration: number) {
    this.videoDuration = duration;
  }

  private toggleVideoPlaying(isVideoPlaying: boolean) {
    this.isVideoPlaying = isVideoPlaying;
  }

  private onVideoCurrentTimeChanged(videoCurrentTimeChange: number) {
    this.videoCurrentTimeChange = videoCurrentTimeChange;
  }

  private onPlaybackRateChanged(playbackRate: number) {
    this.playbackRate = playbackRate;
  }

  @Watch("reviewCommentPlay")
  private onReviewCommentPlay() {
    if (this.reviewCommentPlay > -1) {
      if (this.sessionFeedback && this.sessionFeedback.length > 0) {
        let feedback = this.sessionFeedback[this.reviewCommentPlay];
        if (
          feedback.StartIndex &&
          feedback.EndIndex &&
          this.sessionResult &&
          this.sessionResult.wordStartTimes &&
          this.sessionResult.wordEndTimes
        ) {
          const startPosition = this.sessionResult.wordStartTimes[
            feedback.StartIndex
          ];
          const endPosition = this.sessionResult.wordEndTimes[
            feedback.EndIndex
          ];
          this.playsegment = [startPosition, endPosition];
        }
        this.setReviewCommentPlay(-1);
      }
    }
  }

  private playAudio(playAudio: number[]) {
    this.playsegment = playAudio.slice();
  }

  private handleMouseUp(event: Event) {
    let el = document.getElementById("result-wrapper") as HTMLDivElement;
    this.scrollY = el.scrollTop;
  }

  get isSessionReviewed() {
    return this.sessionReviewed === "true";
  }

  get mediaTypeLabel() {
    if (this.sessionResult && this.sessionResult.videoFileURL) {
      return "Video";
    }
    return "Audio";
  }

  get formattedDuration() {
    if (!this.videoDuration) {
      return "";
    }
    const minutes = Math.floor(this.videoDuration / 60);
    const seconds = Math.floor(this.videoDuration % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  }

  get displayLearnerName() {
    return this.learnerName || this.learnerNameFromResult;
  }

  private getResultLearnerName(newResult: NewResults) {
    const result = newResult as any;
    return result.UserName || result.userName || result.Name || result.name || null;
  }
}
